var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPhi(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 13,
    height: 14,
    viewBox: "0 0 13 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12 0L13 1.07693L10.9662 3.26719C11.7004 4.29485 12.1369 5.58188 12.1369 6.97874C12.1369 10.3432 9.60423 13.0707 6.48006 13.0707C5.18298 13.0707 3.98785 12.6006 3.03362 11.81L1 14L0 12.9231L2.02868 10.7384C1.27355 9.7029 0.823237 8.39749 0.823237 6.97874C0.823237 3.61422 3.35589 0.886741 6.48006 0.886741C7.79743 0.886741 9.00964 1.3717 9.97112 2.18487L12 0ZM9.95478 4.35639L4.04502 10.7207C4.73428 11.2419 5.574 11.5477 6.48006 11.5477C8.82323 11.5477 10.7227 9.50211 10.7227 6.97874C10.7227 6.00294 10.4386 5.0986 9.95478 4.35639ZM6.48006 2.40975C4.13693 2.40975 2.23743 4.45534 2.23743 6.97874C2.23743 7.9765 2.53441 8.89954 3.03836 9.651L8.96144 3.27226C8.26363 2.72958 7.40658 2.40975 6.48006 2.40975Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPhi);
export default __webpack_public_path__ + "static/media/phi.83d0373169b95d29970792fc0a63d089.svg";
export { ForwardRef as ReactComponent };